function validatorCleanErrors(form, formname) {
  form.querySelectorAll(`.errors[id^='${formname}'], .errors[id*='_${formname}_']`).forEach((element) => {
    element.innerHTML = '';
    element.style.display = 'none';
  });
  form.querySelectorAll(`.invalid[id^='${formname}'], .invalid[id*='_${formname}_']`).forEach((element) => {
    element.classList.remove('invalid');
  });
}

function validatorCollectErrors(namespace, errors) {
  const result = {};
  Object.keys(errors).forEach((name) => {
    const joined = `${namespace}[${name}]`;
    if (errors[name] instanceof Array) {
      result[joined] = errors[name];
    } else {
      const innerResult = validatorCollectErrors(joined, errors[name]);
      Object.keys(innerResult).forEach((innerName) => {
        result[innerName] = innerResult[innerName];
      });
    }
  });
  return result;
}

function validatorValidateForm(form, formname, errors) {
  validatorCleanErrors(form, formname);
  const errorsList = validatorCollectErrors(formname, errors);
  Object.keys(errorsList).forEach((name) => {
    const inputName = name.replace(/\[/g, '_').replace(/\]/g, '');
    const errorsElement = form.querySelector(`[id$='${inputName}_errors']`);
    const inputElement = form.querySelector(`[id$='${inputName}']`);
    if (!errorsElement) {
      return;
    }
    const errorsItems = errorsList[name];
    errorsItems.forEach((error) => {
      errorsElement.style.display = '';
      const listItem = document.createElement('li');
      listItem.innerText = error;
      errorsElement.appendChild(listItem);
    });
    if (errorsItems.length > 0) {
      inputElement.classList.add('invalid');
    }
  });
}

export {
  validatorValidateForm,
  validatorCollectErrors,
  validatorCleanErrors,
};